import { Col, Row, Typography } from "antd";
import React from "react";
import DetailBarCard from "../../../../shared/DetailBarCard";

const styles = {
  container: {
    backgroundColor: "#fff",
    borderTop: "solid 1px #e8e8e8",
    marginBottom: "1%",
  },
};
const DetailBar = ({
  name = "",
  dataToDisplay = { visible: false, values: [] },
}) => {
  const DetailBarCards = () => {
    return dataToDisplay.values.map((item, index) => {
      return (
        <Col
          key={`${name}-${index}`}
          className="ant-col-md-flex-auto"
          xs={{ span: 24 }}
        >
          <DetailBarCard {...item} />
        </Col>
      );
    });
  };

  if (!dataToDisplay.visible) return <></>;
  return (
    <React.Fragment>
      <Typography.Title level={4}>{name}</Typography.Title>
      <Row style={styles.container} wrap={true}>
        <DetailBarCards />
      </Row>
    </React.Fragment>
  );
};

export default DetailBar;
